export const zIndex = {
	base: '0',
	dropdown: '100',
};
